import axios from "axios"
import { GetAuditTrailInterFace, Entities } from "types/auditTrail.types"

const ROOT_PATH = "audit-trail"

export default class AuditTrailService {
	static get = (entityId: string, entityName: Entities) =>
		axios.get<Array<GetAuditTrailInterFace>>(`${ROOT_PATH}/${entityId}`, { params: { entityName } })
}
